import axios from 'axios'

const bdcUrl = process.env.VUE_APP_BDC_URL
const bdcToken = 'da5d8d4e-242a-49eb-8050-b0d05571f304'
const token = window.localStorage.getItem('user-token')
const bdcHeaders = {
  'BDC-API-TOKEN': bdcToken,
}
if (token) bdcHeaders['X-Custom-Auth'] = token
export const bdcRepository = axios.create({ 
  baseURL: bdcUrl, 
  headers: bdcHeaders 
})
  
const dspUrl = 'https://dropshipprint.fr/openapi/v1/shops'
const dspToken = 'eOCKvpgUM3rVPjNRW6TuSmda$'
const dspHeaders = {
  'DSP-SECRET-TOKEN': dspToken,
}
export const dspRepository = axios.create({ 
  baseURL: dspUrl, 
  headers: dspHeaders 
})